import { useEffect, useRef } from 'react';
import { useTheme } from 'next-themes';
import { useAuth } from '@/contexts/AuthContext';
import { supabase } from '@/integrations/supabase/client';

/**
 * Hook to sync theme preference from user's profile in database
 * Loads theme on initial mount and whenever user changes
 */
export function useThemeSync() {
  const { theme, setTheme } = useTheme();
  const { user } = useAuth();
  const hasLoadedTheme = useRef(false);

  useEffect(() => {
    const loadThemeFromProfile = async () => {
      if (!user || hasLoadedTheme.current) return;

      try {
        const { data, error } = await supabase
          .from('profiles')
          .select('theme_preference')
          .eq('user_id', user.id)
          .single();

        if (!error && data?.theme_preference) {
          setTheme(data.theme_preference);
          hasLoadedTheme.current = true;
        }
      } catch (error) {
        console.error('Error loading theme preference:', error);
      }
    };

    loadThemeFromProfile();
  }, [user, setTheme]);
}
